import axios from 'axios';
import { AssetFilter, Device } from '../Components/Map/types';
import { Paginated, PaginationQueryWithSearch } from './api';
import { AUTHN_URL } from './urls.mjs';

export type AppLink = {
  url: string;
  app: string;
  clientId: string;
  projectId: string;
  createdAt: string;
};

export type CreateAppLinkDto = {
  app: string;
  expiryEpoch: number;
  clientId: string;
  projectId: string;
};

export type CreateAppLinkResponse = {
  invite: {
    id: string;
    access: [
      {
        type: 'client-project';
        clientId: string;
        projectId: string;
      },
    ];
    createdAt: string;
    updatedAt: string | null;
    expiry: string;
  };
  applink: AppLink;
};

// TODO: Not currently being used. Reimplement when carrying out this ticket: https://geomoby.atlassian.net/browse/LTP-1340
export const getAppLinks = async ({
  Authorization,
  ...query
}: PaginationQueryWithSearch<'clientproject' | 'createdAt'> & {
  Authorization: string;
}) => {
  const queryParams = new URLSearchParams(
    Object.entries(query)
      .map(([key, val]) => [key, val?.toString() || undefined])
      .filter((entry): entry is [string, string] => entry[1] !== undefined),
  );
  return (
    await axios.get<Paginated<AppLink>>(
      `${AUTHN_URL}/open/applink/search?${queryParams.toString()}`,
      { headers: { Authorization } },
    )
  ).data;
};

export const createAppLink = async ({
  Authorization,
  ...dto
}: CreateAppLinkDto & {
  Authorization: string;
}) => {
  return (
    await axios.post<CreateAppLinkResponse>(`${AUTHN_URL}/open/applink`, dto, {
      headers: { Authorization },
    })
  ).data;
};

export const getDevices = async ({
  clientId,
  projectId,
  Authorization,
  perPage,
  page,
  filter,
}: {
  clientId: string;
  projectId: string;
  Authorization: string;
  perPage?: number;
  page: number;
  filter: AssetFilter | undefined;
}) => {
  let filters = `?perPage=${perPage ?? 5}`;
  Object.entries(filter ?? {}).map(([key, value]) => {
    if (key !== undefined && value !== undefined) {
      filters = filters.concat(
        `&${key}=${
          typeof value === 'object'
            ? value.id
            : key === 'order'
            ? value.toString().toLowerCase()
            : value.toString()
        }`,
      );
    }
  });
  return (
    await axios.get<{ devices: Device[]; count: number }>(
      `${AUTHN_URL}/open/device/paginate/${clientId}/${projectId}/${page}${filters}`,
      { headers: { Authorization } },
    )
  ).data;
};
